import { getStudentOption } from './student';
import { getOffersGroupFilters } from './offers';
import { getEngagementGroupFilters } from './engagement';
import { FilterGroup } from 'api-paths-cas';
import { getFinanceGroupFilters } from './finance';
import { getOtherGroupFilters } from './other';
import { IGetFilterGroupsProps } from './types';

export const getStudentDashboardFilterGroups = (props: IGetFilterGroupsProps): FilterGroup[] => {
  return [
    getStudentOption(props),
    getOffersGroupFilters(props),
    getEngagementGroupFilters(props),
    getFinanceGroupFilters(props),
    getOtherGroupFilters(props),
  ];
};
